const st0 = `
.st0{fill-rule:evenodd;clip-rule:evenodd;`


export const OverNightIcon = ({ width, height }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 55 55" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M53.4902 29.8248C52.0458 45.2721 36.5938 56.2299 21.4045 52.8874C-7.39949 46.5577 -3.85207 4.11605 24.9202 1.48999C11.2996 19.6788 35.0569 43.27 53.4902 29.8248Z" fill="#E1F4D3" stroke="#1C452B" strokeWidth="2.98" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    );
};
